// The hosted app calls the Firebase `/api/**` rewrite. That rewrite is the merged API.
const env = import.meta.env;

export function passwordChangeFromSetting(value: string | undefined): boolean {
  return value === "true";
}

export const config = {
  apiBaseUrl: (env.VITE_API_URL as string | undefined) ?? "/api",
  // Kept for the gateway's old compute methods. They use the same rewrite.
  computeBaseUrl: (env.VITE_API_URL as string | undefined) ?? "/api",
  appVersion: "0.1.0",
  firebase: {
    apiKey: env.VITE_FIREBASE_API_KEY as string | undefined,
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined,
    projectId: env.VITE_FIREBASE_PROJECT_ID as string | undefined,
    appId: env.VITE_FIREBASE_APP_ID as string | undefined,
  },
  // API password reset for the sign-in dialog and account-menu "Change password".
  // Hosted builds leave VITE_PASSWORD_CHANGE unset, so this stays off until that
  // environment's frontend build sets it to the string true.
  passwordChange: passwordChangeFromSetting(env.VITE_PASSWORD_CHANGE),
};

export type AppConfig = typeof config;
